/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S16_Link_GizlilikInputs */

const tr_mesafeli_s16_link_gizlilik = /** @type {(inputs: Mesafeli_S16_Link_GizlilikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gizlilik Politikası`)
};

const en_mesafeli_s16_link_gizlilik = /** @type {(inputs: Mesafeli_S16_Link_GizlilikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const de_mesafeli_s16_link_gizlilik = /** @type {(inputs: Mesafeli_S16_Link_GizlilikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzrichtlinie`)
};

const ru_mesafeli_s16_link_gizlilik = /** @type {(inputs: Mesafeli_S16_Link_GizlilikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика конфиденциальности`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Mesafeli_S16_Link_GizlilikInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s16_link_gizlilik = /** @type {((inputs?: Mesafeli_S16_Link_GizlilikInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S16_Link_GizlilikInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s16_link_gizlilik(inputs)
	if (locale === "de") return de_mesafeli_s16_link_gizlilik(inputs)
	if (locale === "ru") return ru_mesafeli_s16_link_gizlilik(inputs)
	return tr_mesafeli_s16_link_gizlilik(inputs)
});